export const Environment = {
  baseApiUrl: '/catWeb',
};
